import React, { useState, useContext, useEffect } from "react"
import _ from "lodash"
import { FirebaseContext } from "../../firebase"
import profileDummy from "../../assets/images/default-profile-avatar.jpg"

export default function StaffProfilePhoto({
  staff_profile_image,
  className = "",
}) {
  const firebase = useContext(FirebaseContext)
  const [profileImageUrl, setProfileImageUrl] = useState(profileDummy)

  useEffect(() => {
    const profileImage = staff_profile_image || ""
    let isMounted = true

    const getProfileImageUrl = async (image) => {
      const { getStorage, ref, getDownloadURL } = firebase.storage
      const storage = getStorage()

      if (_.isEmpty(image)) {
        return profileDummy
      }

      try {
        const logoRef = ref(storage, image)
        return await getDownloadURL(logoRef)
      } catch (error) {
        console.error("Error fetching profile image URL: ", error)
        return profileDummy
      }
    }

    const fetchLogo = async () => {
      const imageUrl = await getProfileImageUrl(profileImage)
      if (isMounted) {
        setProfileImageUrl(imageUrl)
      }
    }

    fetchLogo()

    return () => {
      isMounted = false
    }
  }, [firebase.storage, staff_profile_image])

  return (
    <img
      src={profileImageUrl}
      alt="Profile"
      className={className}
      style={{ marginTop: "1px" }}
    />
  )
}
